import { Injectable, inject } from '@angular/core';
import { DrawerService } from '@/shared/ui-components/drawer/drawer.service';
import { AiChatService } from '../../ai-chat.service';

export const AI_CHAT_DRAWER_ID = 'aiChatDrawer';

@Injectable({ providedIn: 'root' })
export class AiChatDrawerService {
    private readonly _drawerService = inject(DrawerService);
    private readonly _aiChatService = inject(AiChatService);
    private _suggestedQuestionsLoaded = false;

    readonly visible = this._drawerService.getDrawerState(AI_CHAT_DRAWER_ID);

    open(): void {
        if (!this._suggestedQuestionsLoaded) {
            this._suggestedQuestionsLoaded = true;
            this._aiChatService.loadSuggestedQuestions();
        }
        // Recent conversations and guides can change between opens (a new conversation elsewhere, an
        // admin uploading a guide) — cheap GETs, so just refresh every time rather than caching.
        this._aiChatService.loadRecentConversations();
        this._aiChatService.loadGuides();
        this._drawerService.open(AI_CHAT_DRAWER_ID);
    }

    close(): void {
        this._drawerService.close(AI_CHAT_DRAWER_ID);
    }
}
